import React from 'lib/react';
import {
  EVTabs, EVSkeleton, EVPaper, EVGrid,
} from 'lib/components';
import RetryScreen from 'commonComponents/retry-screen';
import PropTypes from 'prop-types';
import { getTabListItems } from './OrderPreferences.utils';
import OrderPreferencesStyles from './OrderPreferencesStyles';

function OrderPreferenceRetry({ handleRetry }) {
  const classes = OrderPreferencesStyles();
  const tabListItems = getTabListItems();

  return (
    <EVGrid container className={classes.orderPreferencesContainer}>
      <EVPaper className={classes.orderPreferencesPaper}>
        <EVGrid className={classes.tabsContainer}>
          <EVTabs
            orientation="vertical"
            variant="scrollable"
            aria-label="tab-list"
            className={classes.tabList}
          >
            {tabListItems.map(({ id }) => (
              // #genai - tab id is the stable identity for each skeleton placeholder
              <EVGrid key={`tabSkeleton-${id}`} className={classes.tabsContainerSkeleton}>
                <EVSkeleton
                  style={{ height: '20px', width: '293px', borderRadius: '6px' }}
                  animation="wave"
                  variant="rect"
                />
              </EVGrid>
            ))}
          </EVTabs>
          <EVGrid className={classes.fillerGrid} />
        </EVGrid>
        <EVGrid container className={classes.pageContainerSkeleton}>
          <RetryScreen handleRetryButtonClick={handleRetry} className={classes.pageContainerRetry} />
        </EVGrid>
      </EVPaper>
    </EVGrid>
  );
}
OrderPreferenceRetry.propTypes = {
  handleRetry: PropTypes.func.isRequired,
};
export default OrderPreferenceRetry;
